/**
 * 特集
 */
export class Feature {

    /** 特集コード. */
    FeatureCode = '';

    /** 特集名. */
    FeatureName = '';

    /** 特集コード名. */
    FeatureCodeName = '';
}
